import '../../styles/sky-cloud-loader.css';

export function SkyCloudLoader({
  hidden = false,
  size = '164px'
}) {
  return (
    <div
      className="sky-loader"
      style={{ '--sky-loader-size': size }}
      hidden={hidden}
      role="status"
      aria-live="polite"
    >
      <div className="sky-loader__mark" aria-hidden="true">
        <svg viewBox="0 0 164 112" fill="none" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <clipPath id="skyLoaderClip">
              <rect x="14" y="66" width="136" height="36" rx="18" />
              <circle cx="44" cy="68" r="26" />
              <circle cx="82" cy="48" r="34" />
              <circle cx="122" cy="66" r="28" />
            </clipPath>
          </defs>
          <g clipPath="url(#skyLoaderClip)">
            <rect x="0" y="0" width="164" height="112" fill="#FFFFFF" />
            <g className="sky-loader__fill">
              <rect x="0" y="108" width="164" height="120" fill="#90CAF8" />
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
}
